import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import QueryClientProvider from '@/providers/QueryClientProvider.tsx';
import { I18nextProvider } from 'react-i18next';
import i18n from './translations/conf/i18n.ts';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';

Sentry.init({
  dsn: 'https://e0bcd51f291ea4a3f486f43973149ebd@sentry.celaneo.com/3',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const container = document.getElementById('root');
if (!container) {
  throw new Error(
    'Failed to find the root element with id "root". Make sure your HTML file contains <div id="root"></div>'
  );
}
const root = createRoot(container);

root.render(
  <StrictMode>
    <QueryClientProvider>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </QueryClientProvider>
  </StrictMode>
);
